const MERMAID_SOURCE_OPENING = /^\s*(?:graph\s+(?:TB|TD|BT|RL|LR)|flowchart\s+(?:TB|TD|BT|RL|LR)|stateDiagram-v2|sequenceDiagram|classDiagram(?:-v2)?|timeline|mindmap)\b/i;

export function looksLikeMermaidSource(value: string): boolean {
  return MERMAID_SOURCE_OPENING.test(value);
}

export function humanReadableVisualPlan(visualPlan: string, rationale: string): string {
  return looksLikeMermaidSource(visualPlan) && !looksLikeMermaidSource(rationale) ? rationale : visualPlan;
}
